const productBundles = wrap => {
	if (!wrap) return;

	// Page load tracking
	const bundles = wrap.querySelectorAll('[id*="productBundle_bundle"]');
	Array.from(bundles).forEach(triggerPageLoadTracking);

	// Click event tracking
	wrap.addEventListener('submit', trackAndDisable);
};

function triggerPageLoadTracking(bundle) {
	const bundleId = bundle.getAttribute('data-bundle-code');
	const cartUrl = bundle.getAttribute('data-cart-url');

	window.od.events.publish('productBundle_Loaded', {
		cartUrl,
		bundleId,
	});
}

function triggerAddBundleTracking(event) {
	const form = event.target;
	const cartUrl = form.getAttribute('data-cart-url');
	const bundleId = form.getAttribute('data-bundle-code');

	window.od.events.publish('productBundle_AddToCart', {
		cartUrl,
		bundleId,
	});
}

function disableBundleButton(event) {
	const form = event.target;
	const productBundleSubmitButton = form.querySelector(
		'[id^="productBundle_submit_bundle_"]',
	);
	productBundleSubmitButton.setAttribute('disabled', '');

	setTimeout(function () {
		productBundleSubmitButton.removeAttribute('disabled');
	}, 3000);
}

function trackAndDisable(event) {
	triggerAddBundleTracking(event);
	disableBundleButton(event);
}
export default productBundles;
